import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// --- THIS IS THE CORRECTED IMPORT PATH ---
import { Tenant } from '../App';

// Define the structure for an action item
interface ActionItem {
  label: string;
  iconPath: string;
  action: () => void;
}

// Update the component props to accept the current tenant
interface QuickActionsProps {
  currentTenant: Tenant | null;
}

const QuickActions: React.FC<QuickActionsProps> = ({ currentTenant }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const iconSize = '25px';

  // ▼▼▼ 1. DEFINE THE PADDING CONSTANT ▼▼▼
  const componentPaddingX = 2;

  const handleAddDataSource = () => {
    if (currentTenant?.id) {
      navigate('/data-sources/add', {
          state: { tenantId: currentTenant.id }
      });
    } else {
        alert("Please select a tenant before adding a data source.");
    }
  };

  const actions: ActionItem[] = [
    {
      label: 'Add New User',
      iconPath: '/icons/user-add-line.svg',
      action: () => navigate('/user-management?action=add-user')
    },
    {
      label: 'Add Data Source',
      iconPath: '/icons/database-2-line.svg',
      action: handleAddDataSource
    },
  ];

  return (
    // ▼▼▼ 2. APPLY THE PADDING TO THE ROOT BOX ▼▼▼
    <Box sx={{ px: componentPaddingX }}>
      <Typography gutterBottom sx={{ fontWeight: 400, fontFamily: 'inter', mb: 1,mt:2 }}>
        Quick Actions
      </Typography>
      <Card elevation={0} sx={{ borderRadius: '8px', backgroundColor: 'background.paper' }}>
        <CardContent sx={{ py: 1.5, px: 0, '&:last-child': { pb: 1.5 } }}>
          <List disablePadding>
            {actions.map((actionItem, index) => (
              <ListItem
                key={actionItem.label}
                disablePadding
                sx={{ mb: index === actions.length - 1 ? 0 : 1.5 }}
              >
                <ListItemButton
                  onClick={actionItem.action}
                  sx={{
                    borderRadius: '12px',
                    backgroundColor: "#FAFAFA",
                    py: 1,
                    px: 1.5,
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36, color: '#4B5563' }}>
                    <img
                      src={process.env.PUBLIC_URL + actionItem.iconPath}
                      alt={`${actionItem.label} icon`}
                      style={{
                        width: iconSize,
                        height: iconSize,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={actionItem.label}
                    primaryTypographyProps={{ fontSize:'12px', sx: { fontWeight: 500 } }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default QuickActions;